import { motion } from "framer-motion";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import AboutCard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <div className="relative min-h-screen bg-gradient-to-b from-dark via-dark-light to-dark py-32 overflow-x-hidden">
      <Particle />

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        {/* About Me Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          {/* Left Column - Text */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8">
              Know Who <span className="text-gradient">I'M</span>
            </h1>
            <AboutCard />
          </motion.div>

          {/* Right Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex justify-center items-center"
          >
            <img
              src={laptopImg}
              alt="about"
              className="w-full max-w-md animate-float"
            />
          </motion.div>
        </div>

        {/* Tech Stack Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-20"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Professional <span className="text-gradient">Skillset</span>
          </h1>
          <Techstack />
        </motion.div>

        {/* Tools Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-20"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-12">
            <span className="text-gradient">Tools</span> I Use
          </h1>
          <Toolstack />
        </motion.div>

        {/* GitHub Calendar */}
        <Github />
      </div>
    </div>
  );
}

export default About;
